import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class TRIXSeries extends Component {
  static yExtents(datum, index, allData, indicator) {
    const dataArr = Array.isArray(allData)
      ? allData
      : Array.isArray(datum)
        ? datum
        : [datum];

    const key = indicator?.renderKey;

    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;

    dataArr.forEach((item) => {
      if (!item) return;
      let v;
      if (key && typeof item[key] === "number") {
        v = item[key];
      } else if (typeof item.trix === "number") {
        v = item.trix;
      } else {
        // As a last resort, scan for a numeric property that starts with 'trix'
        const k = Object.keys(item).find(
          (name) =>
            name.toLowerCase().startsWith("trix") &&
            typeof item[name] === "number",
        );
        if (k) v = item[k];
      }
      if (typeof v === "number" && Number.isFinite(v)) {
        if (v < min) min = v;
        if (v > max) max = v;
      }
    });

    // Ensure zero is always included for oscillators
    if (min > 0) min = 0;
    if (max < 0) max = 0;

    return [min, max];
  }
  render() {
    const {
      className,
      yAccessor,
      stroke,
      zeroLine,
      highlightOnHover,
      onDoubleClick,
      onContextMenu,
      onClick,
    } = this.props;

    return (
      <g className={className}>
        <LineSeries
          yAccessor={yAccessor}
          stroke={stroke}
          highlightOnHover={highlightOnHover}
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          onClick={onClick}
          data-evo-id="trixseries-click-handler"
        />
        <StraightLine yValue={0} stroke={zeroLine} highlightOnHover={false} />
      </g>
    );
  }
}

TRIXSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.object.isRequired,
  zeroLine: PropTypes.object.isRequired,
  highlightOnHover: PropTypes.bool,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  onClick: PropTypes.func,
};

TRIXSeries.defaultProps = {
  className: "react-stockcharts-trix-series",
  highlightOnHover: true,
  stroke: { color: "#808080", dash: "Solid", width: 2, opacity: 1 },
  zeroLine: { color: "#999999", dash: "ShortDash", width: 1, opacity: 0.8 },
};

export default TRIXSeries;
